import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT, saveCard, userProfilePayload } from '../../../constants/globalConstants'
import { getCardDataList, removeCardData, createCardData, makeDefaultCardData } from '../../../redux/actions/cardDetailsAction'
import { encryptionHandler, validExpiryDate } from '../../../utils/helper'
import { Circles } from 'react-loader-spinner'
import ConfermationModal from '../../../components/global/ConfermationModal'
import AddCardModal from '../../../components/global/addCardModal'
import AdminListTablePage from '../../../components/global/dataTable'
import { updateUserProfile, getUserProfile } from '../../../redux/actions/login'
import debounce from 'lodash/debounce'
import MakedefaultModalForm from '../../../components/global/MakedefaultModalForm'

import moment from 'moment/moment'
import useRecaptcha from '../../../Hooks/useRecaptcha'
function PaymentSetting(props) {
    const { current_page, per_page, dispatch, total, partnerDetails, notify } = props
    const [cardList, setCardList] = useState(EMPTY_ARRAY)
    const [expiry, setExpiry] = useState()
    const [card, setCard] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [isEdit, setIsEdit] = useState(false)
    const [error, setError] = useState(false)
    const [payload, setPayload] = useState(saveCard)
    const [isModalOpen, setModal] = useState(false)
    const [confermationModal, setConfermationModal] = useState(false)
    const [deleteItem, setDeleteItem] = useState(EMPTY_ARRAY)
    const [isConsent, setIsConsent] = useState(true)
    const [userUpdatePayload, setUserUpdatePayload] = useState(userProfilePayload)
    const [userData, setUserData] = useState(EMPTY_OBJECT)
    const [images, setImages] = useState({})
    // const [search, setSearch] = useState('')
    const [makedefaultModal, setMakedefaultModal] = useState(false)
    const [defaultItem, setDefaultItem] = useState(EMPTY_ARRAY)
    const [cardDefault, setCardDefault] = useState(false)
    const [deleteConfirmMessage, setDeleteConfirmMessage] = useState('Are you sure you want to delete?')

    // ===== reCAPTCHA v3 Hook =====
    const { getToken } = useRecaptcha()
    // ===== End reCAPTCHA Hook =====


    const columns = [
        { header: 'Card Number', id: 'card_number', accessor: e => e?.card_last_four ? `XXXX XXXX XXXX ${e?.card_last_four}` : '-' },
        { header: 'Expiry Date', id: 'expiry_Date', accessor: e => (e?.expiry !== null && e?.expiry != '') ? <><span className={(checkExpired(e?.expiry) || e?.is_expired == 1) ? 'text-danger fw-bold' : ''}>{e?.expiry?.slice(0, 2)}/{e?.expiry?.slice(-2)}</span>{(checkExpired(e?.expiry) || e?.is_expired == 1) ? <span className='fw-bold border border-danger text-danger d-inline-block p-1 ms-1 rounded-1 small'>Expired</span> : ''}</> : '-' },
        { header: 'Actions', accessor: e => renderRowActions(e) }
    ]


    const checkExpired = (dt) => {
        let yr = dt?.slice(-2)
        let mt = dt?.slice(0, 2)
        // console.log(yr, mt)
        const inputDate = moment('20'+yr+'-'+mt+'-15', 'YYYY-MM-DD')
        const currentDate = moment()
        // Compare year first
        if (inputDate?.year() > currentDate?.year()) {
            return false
        } else if (inputDate?.year() < currentDate?.year()) {
            return true
        } else {
            return inputDate?.month() < currentDate?.month()
        }
    }

    const renderRowActions = (data) => {
        return (
            <div className={`${(data?.is_default === '0') ? 'd-flex' : 'd-flex h-100'} action-btn`}>
                {
                    ((cardList?.length > 1 || validExpiryDate(expiry) || data?.is_expired == 1) && (data?.is_default == '0' || validExpiryDate(expiry) || data?.is_expired == 1)) ? 
                    // (cardList?.length > 1) ? 
                    <a title="Delete" className="mt-0 ms-2 text-danger" href="#" onClick={(event) => {
                        event.stopPropagation()
                        event.preventDefault()
                        handleRemoveCard(event, data?.id)
                    }}>
                        <i className="fa  fa-trash"></i>
                    </a>:''
                }
                {(data?.is_default == '0' && !(validExpiryDate(expiry) || (data?.is_expired && data?.is_expired == 1))) ? 
                
                <a title="Make this default" href="#" className="mt-0 ms-2 text-gray" onClick={(event) => {
                    event.stopPropagation()
                    event.preventDefault()
                    handleDefaultCard(event, data)
                }}>
                    <i className="fa-regular fa-check-circle text-gray opacity-50"></i>
                </a> : null }
                
                {data?.is_default == '0' ? null : <span className='ml-2 ms-2 mt-2 mt-sm-0 small h-100 gap-1 flex-sm-row justify-content-center justify-content-sm-start align-items-center  '>
                    <i className="text-success fa-regular fa-check-circle "></i>
                    <small className='text-nowrap ms-2 ml-2'>Default Card</small>
                </span>}
            </div>
        )
    }


    useEffect(() => {
        paymentListData()
        dispatch(getUserProfile()).then((res) => {
            if (res) {
                const userProfileData = JSON.parse(localStorage.getItem('userData'))
                userProfileData.user = res
                setIsConsent(res?.user_consent == '1' ? true : false)
                if (userProfileData) {
                    localStorage.setItem('userData', JSON.stringify(userProfileData))
                } else {
                    localStorage.setItem('userData', '{}')
                }
                setUserData(res)
                images['front'] = res?.permit?.[0]?.idfront
                images['back'] = res?.permit?.[0]?.idback
                setImages({ ...images })
                if (res?.name !== '') {
                    const formdata = res
                    userUpdatePayload['name'] = formdata?.name ? formdata?.name?.trim() : ''
                    userUpdatePayload['license_number'] = formdata?.license_number ? formdata?.license_number?.trim() : ''
                    userUpdatePayload['email'] = formdata?.email ? formdata?.email?.trim() : ''
                    userUpdatePayload['phone'] = formdata?.phone_number ? formdata?.phone_number?.trim() : ''
                    userUpdatePayload['address'] = formdata?.address ? formdata?.address?.trim() : ''
                    userUpdatePayload['address2'] = formdata?.address2 ? formdata?.address2?.trim() : ''
                    userUpdatePayload['city'] = formdata?.city ? formdata?.city?.trim() : ''
                    userUpdatePayload['state'] = formdata?.state ? formdata?.state?.trim() : ''
                    userUpdatePayload['zipcode'] = formdata?.pincode ? formdata?.pincode?.trim() : ''
                    setUserUpdatePayload({ ...userUpdatePayload })
                }
            }
        })
    }, [EMPTY_ARRAY])



    const handleAutoPayChange = () => {

        setIsConsent(!isConsent)
        let formData = new FormData()     //formdata object
        formData.append('license_number', userUpdatePayload?.license_number ? userUpdatePayload?.license_number : '')
        formData.append('email', userUpdatePayload?.email ? userUpdatePayload?.email : '')
        formData.append('name', userUpdatePayload?.name ? userUpdatePayload?.name : '')
        formData.append('phone', userUpdatePayload?.phone ? userUpdatePayload?.phone : '')
        formData.append('address', userUpdatePayload?.address ? userUpdatePayload?.address : '')
        formData.append('address2', userUpdatePayload?.address2 ? userUpdatePayload?.address2 : '')
        formData.append('city', userUpdatePayload?.city ? userUpdatePayload?.city : '')
        formData.append('state', userUpdatePayload?.state ? userUpdatePayload?.state : '')
        formData.append('zipcode', userUpdatePayload?.zipcode ? userUpdatePayload?.zipcode : '')
        formData.append('image_front', images?.front ? images?.front : '')
        formData.append('image_back', images?.back ? images?.back : '')
        formData.append('permit_id', userData?.permit?.[0]?.id ? userData?.permit?.[0]?.id : '')
        formData.append('user_consent', !isConsent ? 1 : 0)

        deb(formData)


    }

    const deb = useCallback(
        debounce((payload) => {
            dispatch(updateUserProfile(payload)).then((res) => {
                notify('success', 'Autopay consent is updated successfully')
                // setIsUpdatingProfile(false)
                // setDisclaimerNote('')
                const userProfileData = JSON.parse(localStorage.getItem('userData'))
                userProfileData.user = res?.data?.user
                userProfileData.permit = res?.data?.permit
                if (userProfileData) {
                    if (res?.data?.permit?.idfront || res?.data?.permit?.idback) {
                        images['front'] = res?.data?.permit?.idfront ? res?.data?.permit?.idfront : ''
                        images['back'] = res?.data?.permit?.idback ? res?.data?.permit?.idback : ''
                        setImages({ ...images })
                    }
                    localStorage.setItem('userData', JSON.stringify(userProfileData))
                } else {
                    localStorage.setItem('userData', '{}')
                }
                // setEdit(false)
            }).catch(() => {
                notify('success', 'Something went wrong, Please try again!')
                // setDisclaimerNote('')
                // setIsUpdatingProfile(false)
                setErrorMessage({ message: 'Something went wrong, Please try again!' })
            })
        }, 300
        ), [])



    const paymentListData = () => {
        setIsLoading(true)
        const facility_id = partnerDetails?.facilities?.[0]?.id
        dispatch(getCardDataList(facility_id)).then((res) => {
            if(res?.data?.payments){
                setCardList(res?.data?.payments)
            }else{
                setCardList(EMPTY_ARRAY)
            }
            
            setIsLoading(false)
        }).catch(() => {
            setCardList(EMPTY_ARRAY)
            setIsLoading(false)
        })
    }

    const handleInputFieldsData = (e) => {
        const { name, value } = e.target
        setPayload({ ...payload, [name]: value })
    }

    const handleCardChange = (value) => {
        setCard(value?.trim())
        payload['card_number'] = value?.trim()
        setPayload({ ...payload })
    }

    const handleExpiryChange = (value) => {
        setExpiry(value?.trim())
        payload['expiration_date'] = value?.trim()
        setPayload({ ...payload })
    }

    const handleRemoveCard = (e, item) => {
        e.preventDefault()
        const cardToDelete = cardList?.filter((card) => card?.id == item)
        if(cardToDelete?.[0]?.is_default && cardToDelete?.[0]?.is_default == 1){
            setDeleteConfirmMessage('Are you sure you want to delete? The card you are trying to delete is set as Default Card. Please make sure to add a default card for future transactions.')
        }else{
            setDeleteConfirmMessage('Are you sure you want to delete?')
        }
        setDeleteItem(item)
        setConfermationModal(true)
    }

    // Delete Vehicle item
    // Delete Vehicle item
    const handleDelete = () => {
        if (deleteItem) {
            setIsLoading(true)
            let cardDetails = cardList.filter((crd) => {
                return crd.id === deleteItem
            })

            const deleteCardPayload = {
                // facility_id: partnerDetails?.facilities?.[0]?.id,
                id: deleteItem,
                expiry: cardDetails?.[0]?.expiry ? cardDetails?.[0]?.expiry : '',
                card_last_four: cardDetails?.[0]?.card_last_four ? cardDetails?.[0]?.card_last_four : ''
            }
            dispatch(removeCardData(deleteCardPayload)).then((res) => {
                setIsLoading(false)
                setConfermationModal(false)
                if (res?.status === 201 && res?.data !== null) {
                    notify('success', 'Card Deleted')
                    paymentListData()
                } else {
                    notify('error', res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!')
                }
            }).catch((errors) => {
                setIsLoading(false)
                setConfermationModal(false)
                notify('error', errors?.message ? errors?.message : 'Something went wrong, Please try again!')
            })
        }
    }

    const handleisDefault = () => {
        setPayload({ ...payload, is_default: (payload?.is_default == '0') ? '1' : '0' })
    }
    const handleDefaultCard = (e, item) => {
        e.preventDefault()
        setDefaultItem(item)
        setMakedefaultModal(true)
    }
    const handleDefault = () => {
        setIsLoading(true)
        const payload = {
            'id': defaultItem?.id,
            'user_id': defaultItem?.user_id,
            'is_default': 1,
            expiry: defaultItem?.expiry ? defaultItem?.expiry : '',
            card_last_four: defaultItem?.card_last_four ? defaultItem?.card_last_four : ''
        }
        dispatch(makeDefaultCardData(payload)).then((res) => {
            setIsLoading(false)
            setMakedefaultModal(false)
            if (res?.status === 201 && res?.data !== null) {
                notify('success', 'Card Updated')   
                paymentListData()
            }else {
                notify('error', res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!')
            }
        }).catch((errors) => {
            setIsLoading(false)
            setMakedefaultModal(false)
            notify('error', errors?.message ? errors?.message : 'Something went wrong, Please try again!')
        })
    }

    const handleSubmit =async () => {
        setError(true)
        if (Object.values(payload)?.length > 0 && payload?.card_number && ((payload?.card_number?.length === 16 && payload?.security_code?.length != 3) || (payload?.card_number?.length === 15 && payload?.security_code?.length != 4))) {
            setIsLoading(false)
            notify('error', 'Please Enter Valid Card Details')
            return
        }
      

        // ===== reCAPTCHA v3: Generate Token for Add Card =====
        const recaptcha_token = await getToken('save_card')
        if (!recaptcha_token) {
            notify('error', 'Security verification failed. Please try again.')
            setIsLoading(false)
            // setIsSubmitted(false)
            return
        }
        // ===== End reCAPTCHA =====

        payload.recaptcha_token = recaptcha_token

        if (Object.values(payload)?.length > 0 && payload?.card_number && (payload?.card_number?.length === 16 || payload?.card_number?.length === 15) && payload?.expiration_date && payload?.security_code && payload?.cvvErrorMessage == '') {
            const nonce = encryptionHandler(payload)

            // let formData = new FormData()    //formdata object
            // formData.append('nonce', nonce)   //append the values with key, value pair
            // formData.append('payment_type', 'credit_card')   //append the values with key, value pair
            // formData.append('is_auto_deduction', 0)   //append the values with key, value pair

            setIsLoading(true)
            setErrorMessage('')
            // ===== reCAPTCHA v3: Generate Token for Add Card =====
            const recaptcha_token = await getToken('save_card')
            if (!recaptcha_token) {
            notify('error', 'Security verification failed. Please try again.')
            setIsLoading(false)
            // setIsSubmitted(false)
            return
            }
            // ===== End reCAPTCHA =====

            const finalPayload = {
                'nonce': nonce,
                'payment_type': 'credit_card',
                'savePaymentMethod': true,
                //   'facility_id': partnerDetails?.facilities?.[0]?.id,
            }
            if(cardDefault || cardList?.length == 0) {
                finalPayload.is_default = '1'
            }
            finalPayload.recaptcha_token = recaptcha_token
            dispatch(createCardData(finalPayload)).then((res) => {
                setCardDefault(false)
                if (res?.data !== null) {
                    setPayload({ card_number: '', expiration_date: '' })
                    setCard('')
                    setExpiry('')
                    setIsEdit(false)
                    setModal(false)
                    setError(false)
                    paymentListData()
                    saveCard.is_default = 0
                    setPayload(saveCard)
                } else if (res?.data === null && res?.errors?.message) {
                    setErrorMessage(res?.errors?.message)
                    setIsLoading(false)
                }
            }).catch((err) => {
                // setErrorMessage(err?.errors?.message)
                notify('error' , err?.errors?.message ? err?.errors?.message : 'Something went wrong, Please try again!')
            })
        } else {
            setIsLoading(false)
            setErrorMessage('')
        }
    }

    const handleModalOpen = () => {
        setModal(true)
    }

    return (
        <div>
            <div className="d-flex mb-4">
                <h4 className="fw-bold">Payment Settings </h4>
                <button className="btn btn-primary ms-auto" onClick={handleModalOpen}><i className="fa fa-plus"></i> Add</button>
            </div>
            {isLoading ? <span className='ms-2 d-flex justify-content-center'><Circles
                height="50"
                width="50"
                color="var(--bs-primary)"
                ariaLabel="circles-loading"
                visible={true}
            /></span> :
                <div className="card mb-3">
                    <div className="card-header">  <b>Card List</b> </div>
                    <AdminListTablePage
                        data={cardList}
                        columns={columns}
                        getNewRecords={paymentListData}
                        curPage={current_page}
                        perPage={per_page}
                        total={total}
                        showSearch={false}
                        hideSrnumber={true}
                    />
                    <div className="container p-0">
                        <div className="card">
                            <div className="card-header">
                                <div className="d-flex">
                                    <h5 className="mb-0">AutoPay Settings</h5>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row"></div>
                                <span className="switch-wrap">
                                    <label className="switch">
                                        <input type="checkbox" id='autopayconsent' name='autopayconsent' checked={isConsent} onChange={() => handleAutoPayChange()} />
                                        <span className="slider round"></span>
                                    </label>
                                    <label htmlFor="autopayconsent" className='ps-2' > AutoPay Consent </label>
                                    {/* <i className='ps-2 fa-sm fa fa-info-circle' onClick={() => setDisplayModal(true)}></i> */}
                                </span>
                                <i className='d-block small'>By clicking this button, you are providing your consent for auto renewal.</i>

                            </div>
                        </div>
                    </div>
                </div>}

            <AddCardModal cardList={cardList} isModalOpen={isModalOpen} setModal={setModal} setPayload={setPayload} payload={payload} modalName='Add New Card' isLoading={isLoading} handleCardChange={handleCardChange} handleExpiryChange={handleExpiryChange} handleSubmit={handleSubmit} expiry={expiry} card={card} errorMessage={errorMessage} isEdit={isEdit} error={error} setErrorMessage={setErrorMessage} setError={setError} setCard={setCard} setExpiry={setExpiry} handleInputFieldsData={handleInputFieldsData} partnerDetails={partnerDetails} handleisDefault={handleisDefault} setCardDefault={setCardDefault} cardDefault={cardDefault}/>
            <ConfermationModal setConfermationModal={setConfermationModal} confermationModal={confermationModal} confermationHeading='Confirm Delete' confermationMessage={deleteConfirmMessage} buttonLable='Delete' handleDelete={handleDelete} />
            <MakedefaultModalForm setMakedefaultModal={setMakedefaultModal} makedefaultModal={makedefaultModal} makeDefaultHeading='Make this default' confermationMessage='Are you sure you want to make this default?' buttonLable='Make Default' handleDefault={handleDefault} />
        </div>
    )
}

PaymentSetting.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    current_page: PropTypes.number,
    per_page: PropTypes.number,
    total: PropTypes.number,
    partnerDetails: PropTypes.object,
    notify: PropTypes.func,
}

PaymentSetting.defaulProps = {
    dispatch: noop,
    partnerDetails: {},
    loader: PropTypes.bool,
    notify: noop,
}
function mapStateToProps({ cardDetailsReducer, PartnerReducer }) {
    const { current_page, per_page, total, loader } = cardDetailsReducer
    return {
        loader,
        current_page,
        per_page,
        total,
        partnerDetails: PartnerReducer?.partnerDetails?.data,
    }
}
export default connect(mapStateToProps)(PaymentSetting)